<div class="billing-container">
  <!-- Tabs for navigation -->
  <mat-tab-group class="billing-tabs" [selectedIndex]="activeTabIndex" (selectedIndexChange)="onTabChange($event)" animationDuration="300ms">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">shopping_cart</mat-icon>
        <span>Plans</span>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">account_balance_wallet</mat-icon>
        <span>My Subscription</span>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">receipt_long</mat-icon>
        <span>Billing History</span>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <!-- Plans Tab Content -->
  <div class="tab-content" *ngIf="activeTabIndex === 0 && !selectedPlan">
    <div class="header">
      <h1>Choose Your Plan</h1>
      <p>Select the perfect plan for your fitness journey and take your training to the next level</p>
    </div>

    <div class="plans-info">
      <p>Choose the plan that best fits your organization's needs</p>
    </div>

    <!-- Loading Spinner -->
    <div class="loading-plans" *ngIf="isLoadingPlans">
      <div class="loading-animation">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      <p>Loading available plans...</p>
    </div>

    <!-- Error Message -->
    <div class="no-plans" *ngIf="!isLoadingPlans && plans.length === 0">
      <mat-icon class="no-data-icon">error_outline</mat-icon>
      <h2>Unable to load plans</h2>
      <p>We couldn't load the subscription plans. Please try refreshing the page.</p>
      <button mat-raised-button color="primary" (click)="loadPlans()">
        Retry
      </button>
    </div>

    <!-- Plans Grid -->
    <div class="plans-grid" *ngIf="!isLoadingPlans && plans.length > 0">
      <mat-card class="plan-card" *ngFor="let plan of plans" 
                [class.popular]="plan.popular"
                (click)="selectPlan(plan)">
        <div class="popular-tag" *ngIf="plan.popular">
          <mat-icon>star</mat-icon>
          <span>MOST POPULAR</span>
        </div>
        <mat-card-header>
          <mat-card-title>{{plan.name}}</mat-card-title>
          <mat-card-subtitle>
            <div class="plan-description">{{plan.description}}</div>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="price">
            <span class="currency">$</span>
            <span class="amount">{{plan.amount}}</span>
            <span class="period">/{{plan.interval}}</span>
          </div>
          
          <div class="plan-limits" *ngIf="plan.parsedFeatures">
            <div class="limit-item">
              <mat-icon>people</mat-icon>
              <span>{{plan.parsedFeatures.clients}} clients</span>
            </div>
            <div class="limit-item">
              <mat-icon>supervisor_account</mat-icon>
              <span>{{plan.parsedFeatures.consultants}} consultants</span>
            </div>
          </div>
          
          <ul class="features">
            <ng-container *ngIf="plan.parsedFeatures && plan.parsedFeatures.features">
              <li *ngFor="let feature of plan.parsedFeatures.features">
                <mat-icon class="feature-icon">check_circle</mat-icon>
                <span>{{feature}}</span>
              </li>
            </ng-container>
          </ul>
        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button class="select-button">
            <span>Select Plan</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>

  <!-- My Subscription Tab Content -->
  <div class="tab-content" *ngIf="activeTabIndex === 1 && !selectedPlan">
    <div class="header">
      <h1>My Subscription</h1>
      <p>Manage your current subscription and billing details</p>
    </div>

    <div class="subscription-container" *ngIf="hasActiveSubscription; else noSubscription">
      <div class="subscription-card">
        <div class="subscription-header">
          <div class="subscription-info">
            <h2>{{currentSubscription.plan}} Plan</h2>
            <div class="subscription-badge" [ngClass]="currentSubscription.status">
              {{currentSubscription.status}}
            </div>
          </div>
          <div class="subscription-price">
            <span class="currency">$</span>
            <span class="amount">{{currentSubscription.amount}}</span>
            <span class="period">/{{currentSubscription.billingCycle}}</span>
          </div>
        </div>

        <div class="subscription-details">
          <div class="detail-item">
            <mat-icon>calendar_today</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Next billing date</span>
              <span class="detail-value">{{currentSubscription.nextBillingDate | date:'mediumDate'}}</span>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon>credit_card</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Payment method</span>
              <span class="detail-value">•••• •••• •••• {{currentSubscription.lastFourDigits}}</span>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon>access_time</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Subscription started</span>
              <span class="detail-value">{{currentSubscription.startDate | date:'mediumDate'}}</span>
            </div>
          </div>
        </div>

        <div class="subscription-actions">
          <button mat-stroked-button color="primary" class="action-button" (click)="updatePaymentMethod()">
            <mat-icon>credit_card</mat-icon>
            Update Payment Method
          </button>
          <button mat-stroked-button color="primary" class="action-button" (click)="changePlan()">
            <mat-icon>swap_horiz</mat-icon>
            Change Plan
          </button>
          <button mat-stroked-button color="warn" class="action-button cancel-button" (click)="openCancelDialog()">
            <mat-icon>cancel</mat-icon>
            Cancel Subscription
          </button>
        </div>
      </div>
    </div>

    <ng-template #noSubscription>
      <div class="no-subscription">
        <mat-icon class="no-data-icon">subscriptions_off</mat-icon>
        <h2>No Active Subscription</h2>
        <p>You don't have an active subscription at the moment.</p>
        <button mat-raised-button color="primary" (click)="activeTabIndex = 0">
          View Available Plans
        </button>
      </div>
    </ng-template>
  </div>

  <!-- Billing History Tab Content -->
  <div class="tab-content" *ngIf="activeTabIndex === 2 && !selectedPlan">
    <div class="header">
      <h1>Billing History</h1>
      <p>View your past transactions and download receipts</p>
    </div>

    <div class="transaction-history-container" *ngIf="transactionHistory.length > 0; else noTransactions">
      <div class="filter-controls">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search transactions</mat-label>
          <input matInput placeholder="Search by ID or plan">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        
        <mat-form-field appearance="outline">
          <mat-label>Filter by status</mat-label>
          <mat-select>
            <mat-option value="all">All</mat-option>
            <mat-option value="completed">Completed</mat-option>
            <mat-option value="pending">Pending</mat-option>
            <mat-option value="failed">Failed</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="transactions-wrapper">
        <table mat-table [dataSource]="transactionHistory" class="transactions-table">
          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let transaction">
              <div class="cell-content">
                <span class="primary-text">{{transaction.date | date:'MMM d, yyyy'}}</span>
                <span class="secondary-text">{{transaction.date | date:'shortTime'}}</span>
              </div>
            </td>
          </ng-container>
          
          <!-- Transaction ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
            <td mat-cell *matCellDef="let transaction">
              <div class="cell-content">
                <span class="primary-text transaction-id">{{transaction.id}}</span>
              </div>
            </td>
          </ng-container>
          
          <!-- Plan Column -->
          <ng-container matColumnDef="plan">
            <th mat-header-cell *matHeaderCellDef>Plan</th>
            <td mat-cell *matCellDef="let transaction">
              <div class="cell-content">
                <span class="primary-text">{{transaction.plan}}</span>
                <span class="secondary-text">Annual subscription</span>
              </div>
            </td>
          </ng-container>
          
          <!-- Amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let transaction">
              <div class="cell-content">
                <span class="primary-text amount">${{transaction.amount}}</span>
              </div>
            </td>
          </ng-container>
          
          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let transaction">
              <div class="status-badge" [ngClass]="transaction.status.toLowerCase()">
                {{transaction.status}}
              </div>
            </td>
          </ng-container>
          
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let transaction">
              <button mat-icon-button color="primary" (click)="viewReceipt(transaction)" matTooltip="View Receipt">
                <mat-icon>receipt</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="downloadReceipt(transaction)" matTooltip="Download PDF">
                <mat-icon>download</mat-icon>
              </button>
            </td>
          </ng-container>
          
          <tr mat-header-row *matHeaderRowDef="['date', 'id', 'plan', 'amount', 'status', 'actions']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['date', 'id', 'plan', 'amount', 'status', 'actions']"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>

    <ng-template #noTransactions>
      <div class="no-transactions">
        <mat-icon class="no-data-icon">receipt_long</mat-icon>
        <h2>No Transaction History</h2>
        <p>You don't have any billing history yet.</p>
        <button mat-raised-button color="primary" (click)="activeTabIndex = 0">
          View Available Plans
        </button>
      </div>
    </ng-template>
  </div>

  <!-- Payment Section -->
  <div class="payment-section" *ngIf="selectedPlan">
    <div class="payment-header">
      <button mat-icon-button (click)="goBack()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2>Complete Your Purchase</h2>
    </div>

    <div class="payment-content">
      <div class="order-summary">
        <h3>Order Summary</h3>
        <div class="plan-details">
          <div class="plan-name-container">
            <div class="plan-name">{{selectedPlan.name}} Plan ({{selectedPlan.interval}}ly)</div>
            <div class="plan-tag" *ngIf="selectedPlan.popular">
              <mat-icon>star</mat-icon>
              <span>POPULAR CHOICE</span>
            </div>
          </div>
          <div class="plan-price">${{selectedPlan.amount}}</div>
        </div>
        
        <div class="plan-limits-summary" *ngIf="selectedPlan.parsedFeatures">
          <div class="limit-item">
            <mat-icon>people</mat-icon>
            <span>{{selectedPlan.parsedFeatures.clients}} clients</span>
          </div>
          <div class="limit-item">
            <mat-icon>supervisor_account</mat-icon>
            <span>{{selectedPlan.parsedFeatures.consultants}} consultants</span>
          </div>
        </div>
        
        <div class="plan-features">
          <ng-container *ngIf="selectedPlan.parsedFeatures && selectedPlan.parsedFeatures.features">
            <div class="feature-item" *ngFor="let feature of selectedPlan.parsedFeatures.features | slice:0:3">
              <mat-icon class="feature-icon">check_circle</mat-icon>
              <span>{{feature}}</span>
            </div>
            <div class="feature-item more-features" *ngIf="selectedPlan.parsedFeatures.features.length > 3">
              <mat-icon class="feature-icon">add_circle_outline</mat-icon>
              <span>And {{selectedPlan.parsedFeatures.features.length - 3}} more benefits</span>
            </div>
          </ng-container>
        </div>
        
        <div class="divider"></div>
        
        <div class="total">
          <span>Total</span>
          <span class="total-price">${{selectedPlan.amount}}</span>
        </div>
        
        <div class="billing-cycle">
          <mat-icon>calendar_today</mat-icon>
          <span>Billed {{selectedPlan.interval}}ly. Next payment on {{selectedPlan.interval === 'month' ? getNextMonthDate() : getNextYearDate() | date:'mediumDate'}}</span>
        </div>

        <div class="promo-code">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Promo Code</mat-label>
            <input matInput placeholder="Enter promo code">
            <button mat-button matSuffix color="primary">Apply</button>
          </mat-form-field>
        </div>
      </div>

      <div class="payment-form">
        <h3>Proceed to Checkout</h3>
        
        <div class="checkout-info">
          <p>You'll be redirected to Stripe's secure checkout page to complete your payment.</p>
          
          <div class="secure-payment-info">
            <mat-icon>verified_user</mat-icon>
            <div>
              <h4>Secure Payment</h4>
              <p>Your payment information is protected with industry-standard encryption.</p>
            </div>
          </div>
          
          <div class="payment-methods-info">
            <mat-icon>credit_card</mat-icon>
            <div>
              <h4>Multiple Payment Methods</h4>
              <p>Pay with credit card, debit card, or other payment methods supported by Stripe.</p>
            </div>
          </div>
        </div>
        
        <button mat-raised-button
                class="pay-button" 
                [disabled]="isProcessing"
                (click)="processPayment()">
          <div class="button-content">
            <mat-spinner *ngIf="isProcessing" diameter="20" class="spinner"></mat-spinner>
            <span *ngIf="!isProcessing">Proceed to Checkout</span>
            <span *ngIf="isProcessing">Redirecting to Stripe...</span>
          </div>
        </button>
        
        <div class="secure-payment">
          <mat-icon>lock</mat-icon>
          <span>Secure payment processed by Stripe</span>
        </div>
        
        <div class="payment-policies">
          <p>By completing your purchase, you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Success Section is now handled by TransactionSuccessComponent -->

  <!-- Cancel Subscription Dialog (Hidden, shown via openCancelDialog method) -->
  <div class="cancel-dialog" *ngIf="showCancelDialog">
    <div class="cancel-dialog-content">
      <div class="cancel-dialog-header">
        <h2>Cancel Subscription</h2>
        <button mat-icon-button (click)="closeCancelDialog()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <div class="cancel-dialog-body">
        <div class="warning-icon">
          <mat-icon>warning</mat-icon>
        </div>
        
        <h3>Are you sure you want to cancel?</h3>
        <p>Your subscription will remain active until the end of your current billing period on <strong>{{currentSubscription?.nextBillingDate | date:'mediumDate'}}</strong>.</p>
        
        <div class="benefits-reminder">
          <h4>You'll lose access to:</h4>
          <ul>
            <li *ngFor="let feature of currentSubscriptionFeatures">
              <mat-icon>check_circle</mat-icon>
              <span>{{feature}}</span>
            </li>
          </ul>
        </div>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Reason for cancellation</mat-label>
          <mat-select [(value)]="cancellationReason">
            <mat-option value="too_expensive">Too expensive</mat-option>
            <mat-option value="not_using">Not using enough</mat-option>
            <mat-option value="missing_features">Missing features</mat-option>
            <mat-option value="switching">Switching to another service</mat-option>
            <mat-option value="other">Other reason</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="full-width" *ngIf="cancellationReason === 'other'">
          <mat-label>Please specify</mat-label>
          <textarea matInput rows="3" placeholder="Tell us why you're cancelling..."></textarea>
        </mat-form-field>
      </div>
      
      <div class="cancel-dialog-actions">
        <button mat-stroked-button (click)="closeCancelDialog()">
          Keep Subscription
        </button>
        <button mat-raised-button color="warn" [disabled]="isCancelling" (click)="confirmCancellation()">
          <div class="button-content">
            <mat-spinner *ngIf="isCancelling" diameter="20" class="spinner"></mat-spinner>
            <span *ngIf="!isCancelling">Confirm Cancellation</span>
            <span *ngIf="isCancelling">Processing...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>